Backbone = require 'backbone'

class SupportFlexibleContactChannelModel extends Backbone.Model
  initialize: ->
    @url = "#{window.SUPPORTBASEURL}/fetch?key=contact_channels&type=contact_channels"

  setFetchContactChannelFromCMS: ->
    @url = "#{@url}&should_display_cms_content=true"

  hasContactChannels : () ->
    @has('contact_channels')

  getContactChannels : () ->
    @get('contact_channels')

  setFlexibleContactChannels: (contactChannelsForSelectedSubcategory) ->
    @set "flexbleContactChannels", contactChannelsForSelectedSubcategory

  invalidateFlexibleContactChannels: () ->
    @set "flexbleContactChannels", null

  presentContactChannels:()->
    if @has('flexbleContactChannels')
      contactChannels = @get('flexbleContactChannels')
      formattedContactChannels = []
      _.each contactChannels, (value, key)=>
        key = key?.toLowerCase()
        value = value?.toLowerCase()
        formattedContactChannel = {}
        formattedContactChannel[key] = @getContactChannelHash(value)
        if value is 'chat' then @set 'liveChatExists', true
        formattedContactChannels.push formattedContactChannel
      @set "formattedContactChannels", {contact_channels: formattedContactChannels}
    else
      @set 'liveChatExists', true
      @set "formattedContactChannels", {contact_channels: @getDefaultContactChannelsWithChat()}
    @setBoldchatRelatedInfoInFlexibleContactChannels()

  setBoldchatRelatedInfoInFlexibleContactChannels:()->
    if @has('formattedContactChannels')
      formattedContactChannels = @get("formattedContactChannels")['contact_channels']
      @set('primaryChannelIsBoldChat', (formattedContactChannels?[0]?['primary']?.is_chat is true))
      @set('onlyBoldChatInContactChannels', (formattedContactChannels.length is 1) and @get('primaryChannelIsBoldChat'))
    @setContactChannelsWithoutBoldChat()

  setContactChannelsWithoutBoldChat:()->
    if @get('onlyBoldChatInContactChannels')
      @set("contactChannelsWithoutBoldChat", {
        contact_channels: [
          {
            primary: @getContactChannelHash("email")
          }
        ]
      })
    else if @has('formattedContactChannels')
      channelTypes = ['primary', 'secondary', 'tertiary']
      i = 0
      contactChannelsWithoutBoldChat = [{}, {}, {}]
      contact_channels = _.each(@get("formattedContactChannels").contact_channels, (formattedContactChannel, key)-> unless formattedContactChannel[channelTypes[key]]?.is_chat then contactChannelsWithoutBoldChat[i][channelTypes[i++]] = formattedContactChannel[channelTypes[key]])
      _.each(contactChannelsWithoutBoldChat, (contactChannelWithoutBoldChat, key)-> if _.isEmpty(contactChannelWithoutBoldChat) then contactChannelsWithoutBoldChat.splice(key, 1))
      @set("contactChannelsWithoutBoldChat", {contact_channels: contactChannelsWithoutBoldChat})
    else
      @set("contactChannelsWithoutBoldChat", { contact_channels: @getDefaultContactChannelsWithoutChat()})

  getDefaultContactChannelsWithChat : ->
    [
      {
        primary: @getContactChannelHash("chat")
      },
      {
        secondary: @getContactChannelHash("email")
      },
      {
        tertiary: @getContactChannelHash("phone")
      }
    ]

  getDefaultContactChannelsWithoutChat : ->
    [
      {
        primary: @getContactChannelHash("email")
      },
      {
        secondary: @getContactChannelHash("phone")
      }
    ]

  getContactChannelHash : (type) ->
    switch type
      when "chat"
        return @chatContactChannelHash()
      when "email"
        return @emailContactChannelHash()
      when "phone"
        return @phoneContactChannelHash()


  chatContactChannelHash: ->
    {
      "channel": "chat", button_text: I18n.translate('js.modules.support.chat'), channel_text: I18n.translate('js.modules.support.chat_us'), is_chat: true
    }

  emailContactChannelHash: ->
    {
      "channel": "email", button_text: I18n.translate('js.modules.support.email'), channel_text: I18n.translate('js.modules.support.email_us'), is_chat: false
    }

  phoneContactChannelHash: ->
    {
      "channel": "phone", button_text: I18n.translate("js.modules.support.flexible_phone"), channel_text: I18n.translate('js.modules.support.phone_us'), is_chat: false
    }

module.exports = SupportFlexibleContactChannelModel
